import React from 'react'
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import axios from 'axios';


const Logout = () => {
    const navigate = useNavigate(); 
    const handlelogout=()=>{
       localStorage.setItem("user", JSON.stringify(""));
       navigate("/");
    }
  return (
    <Button color="inherit" onClick={handlelogout}>Logout</Button>
  )
}

export default Logout
